import updateHomepageSettingsSignup from '../../../actions/siteadmin/updateHomepageSettingsSignup'
import { demoRestriction } from '../../../actions/demoRestriction';

async function submit(values, dispatch) {
    const isRestrict = await dispatch(demoRestriction({}));
    if (isRestrict) return;
    await dispatch(updateHomepageSettingsSignup(values))
}

export default submit;